import {
    Component,
    componentService,
    element as $,
    elements as $$,
    LocalStorage,
    requestService,
    services
} from '@contorion/core';
import { IProductService } from '../interfaces/product-service.interface';
import {
    ITrackingScriptsService
} from '../../tracking-scripts/interfaces/tracking-scripts-service.interface';
import { Ga4ViewItemEvent } from "../../google/components/Ga4ViewItemEvent.component";
import { Ga4ViewItemEventParams } from "../../google/constants/event-params.constants";

const SELECTOR_PRODUCT_DETAIL: string = '.js-product-detail';
const SELECTOR_SKU: string = '.js-sku';
const SELECTOR_VIDEO_WRAPPER: string = '.js-video-wrapper';
const SELECTOR_BUNDLE_COMPONENT_ITEM: string = '.js-bundle-component-item';
const SELECTOR_RELATED_SETS_SECTION: string = '.js-related-sets-section';

export class ProductDetailComponent extends Component {
    protected productService: IProductService;
    protected trackingScriptsService: ITrackingScriptsService;
    protected localStorage: LocalStorage = new LocalStorage();

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        this.trackingScriptsService = await services.get('tracking-scripts-service');
        this.productService = await services.get('product-service');
        this.productService.subscribeUrl(this.onUrlChange.bind(this));
        if(this.bundleComponentItems) {
            this.bundleComponentItems.forEach((item: HTMLElement) => {
                item.addEventListener('click', this.bundleComponentItemClickHandler.bind(this));
            });
        }
        if(this.relatedSetsSection) {
            this.relatedSetsSection.addEventListener('click', this.relatedSetsSectionClickHandler.bind(this));
        }
    }

    protected get sku(): HTMLElement {
        return <HTMLElement> $(SELECTOR_SKU, this.element);
    }

    protected get productId(): string {
        const tcVars = window.tc_vars;

        return tcVars.product_id;
    }

    protected get videoWrapper(): HTMLElement {
        return <HTMLElement> $(SELECTOR_VIDEO_WRAPPER);
    }

    protected get bundleComponentItems(): Array<HTMLElement> {
        return $$<HTMLElement>(SELECTOR_BUNDLE_COMPONENT_ITEM, this.element);
    }

    protected get relatedSetsSection(): HTMLElement {
        return <HTMLElement> $(SELECTOR_RELATED_SETS_SECTION, this.element);
    }

    protected relatedSetsSectionClickHandler() {
        if (this.productId) {
            this.localStorage.setValue(Ga4ViewItemEventParams.clickOnBundleBanner, this.productId);
        }
    }

    protected bundleComponentItemClickHandler() {
        if (this.productId) {
            this.localStorage.setValue(Ga4ViewItemEventParams.clickOnBundleItem, this.productId);
        }
    }

    protected async load(url: string): Promise<void> {
        const content = await requestService
            .get(url)
            .then((response: Response) => response.text());

        this.replace(content);
    }

    protected replace(content: string): void {
        const vdom: HTMLElement = document.createElement('div');
        vdom.innerHTML = content;

        const newElement = vdom.querySelector(SELECTOR_PRODUCT_DETAIL);
        const tcVarsScript = vdom.querySelector(this.trackingScriptsService.tcVarsScriptSelector);
        const scripts = vdom.querySelector(this.trackingScriptsService.bodyTrackingSelector);
        const skuToUpdateFrom: string = this.sku?.innerText;

        if (!newElement) {
            return;
        }

        this.element.innerHTML = newElement.innerHTML;
        componentService.load(this.element);

        if (this.videoWrapper) {
            componentService.load(this.videoWrapper);
        }

        if (this.sku?.innerText !== skuToUpdateFrom) {
            this.trackingScriptsService.setBodyTrackingScripts(scripts.innerHTML);
            this.trackingScriptsService.updateTcVarsScript(tcVarsScript.innerHTML);
        }

        Ga4ViewItemEvent.loadByElement(this.element);

    }

    protected onUrlChange(url: string): void {
        if (url === null) {
            return;
        }

        this.load(url);
    }
}
